module.exports = __webpack_public_path__ + "img/pr-9.71aae513.png";